import { useEffect, useContext, useState, useCallback } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function usePrompt(message, when, showCustomModal) {
  const { navigator } = useContext(NavigationContext);
  const [showPrompt, setShowPrompt] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const confirmNavigation = useCallback(() => {
    if (pendingNavigation) {
      const push = pendingNavigation.push;
      const args = pendingNavigation.args;
      push(...args);
      setPendingNavigation(null);
    }
    setShowPrompt(false);
  }, [pendingNavigation]);

  const cancelNavigation = useCallback(() => {
    setPendingNavigation(null);
    setShowPrompt(false);
  }, []);

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      if (showCustomModal) {
        // Store the navigation details and show custom modal
        setPendingNavigation({ push, args });
        setShowPrompt(true);
      } else {
        // Use default browser confirm
        const result = window.confirm(message);
        if (result) {
          push(...args);
        }
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, message, when, showCustomModal]);

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [message, when]);

  return {
    showPrompt,
    confirmNavigation,
    cancelNavigation,
  };
}
